import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

/**
 * В cookie-режиме refresh-токен живёт в httpOnly-куке и недоступен JS. Чтобы вся
 * существующая логика «есть ли сессия / есть чем рефрешить» (которая читает
 * localStorage.refreshToken) продолжала работать без переписывания, в localStorage
 * держим этот маркер вместо реального токена. Реальный токен — только в куке.
 */
export const COOKIE_RT_SENTINEL = '__rt_httponly_cookie__';

export type AuthTransportMode = 'cookie' | 'body';

export interface AuthTransport {
  mode: AuthTransportMode;
  /** База auth-эндпоинтов. В cookie-режиме — same-site API-хост (кука first-party). */
  apiUrl: string;
  withCredentials: boolean;
}

// CRM-домены → свой same-site API-хост, чтобы httpOnly-кука была first-party:
//   crm.getluxe.ru      → api.getluxe.ru      (site getluxe.ru)
//   crm.xeotravel.ru    → api.xeotravel.ru    (site xeotravel.ru)
//   crm-dev.xeotravel.ru→ api-dev.xeotravel.ru(site xeotravel.ru; dev-CRM и так ходит
//                          в api-dev.xeotravel.ru — тот же backend/БД, same-site)
// localhost/неизвестное остаётся на теле (environment.apiUrl): Secure-кука по http
// локально не ставится — менять там транспорт незачем.
const COOKIE_HOST_TO_API: Record<string, string> = {
  'crm.getluxe.ru': 'https://api.getluxe.ru/api',
  'crm.xeotravel.ru': 'https://api.xeotravel.ru/api',
  'crm-dev.xeotravel.ru': 'https://api-dev.xeotravel.ru/api',
};

@Injectable({
  providedIn: 'root',
})
export class AuthTransportService {
  private readonly transport: AuthTransport = this.resolve();

  get(): AuthTransport {
    return this.transport;
  }

  private resolve(): AuthTransport {
    const host =
      typeof window !== 'undefined' && window.location
        ? window.location.hostname
        : '';
    const cookieApiUrl = COOKIE_HOST_TO_API[host];

    if (cookieApiUrl) {
      return { mode: 'cookie', apiUrl: cookieApiUrl, withCredentials: true };
    }

    return { mode: 'body', apiUrl: environment.apiUrl, withCredentials: false };
  }
}
